export default {
    unspecified: {
        event: 'EVENT_CODE_UNSPECIFIED',
        type: 'EVENT_TYPE_UNSPECIFIED',
    },
    reportAdsPlaybackFailedEvent: {
        event: 'ADS_PLAYBACK_FAILED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsPlaybackStartedEvent: {
        event: 'ADS_PLAYBACK_STARTED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsPlaybackFinishedEvent: {
        event: 'ADS_PLAYBACK_FINISHED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportUserPlayClickedEvent: {
        event: 'USER_PLAY_CLICKED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportListenSessionStartedEvent: {
        event: 'LISTEN_SESSION_STARTED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportApplicationSessionStartedEvent: {
        event: 'APP_SESSION_STARTED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsVideoAudioRollRequestedEvent: {
        event: 'ADS_VIDEO_AUDIO_ROLL_REQUESTED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsVideoAudioRollRequestFailedEvent: {
        event: 'ADS_VIDEO_AUDIO_ROLL_REQUEST_FAILED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsVideoAudioRollResponseReceivedEvent: {
        event: 'ADS_VIDEO_AUDIO_ROLL_RESPONSE_RECEIVED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsVideoAudioRollEligibilityDecidedEvent: {
        event: 'ADS_VIDEO_AUDIO_ROLL_ELIGIBILITY_DECIDED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsDisplayRequestedEvent: {
        event: 'ADS_DISPLAY_REQUESTED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsDisplayResponseReceivedEvent: {
        event: 'ADS_DISPLAY_RESPONSE_RECEIVED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsDisplayRequestFailedEvent: {
        event: 'ADS_DISPLAY_REQUEST_FAILED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsDisplayImpressionEvent: {
        event: 'ADS_DISPLAY_IMPRESSION',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsDisplayViewabilityStatusEvent: {
        event: 'ADS_DISPLAY_VIEWABILITY_STATUS',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsDisplayClickedEvent: {
        event: 'ADS_DISPLAY_CLICKED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsInstreamReceivedEvent: {
        event: 'ADS_INSTREAM_RECEIVED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsInstreamStartedEvent: {
        event: 'ADS_INSTREAM_STARTED',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsInstreamQuartileStatusEvent: {
        event: 'ADS_INSTREAM_QUARTILE_STATUS',
        type: 'EVENT_TYPE_TRACK',
    },
    reportAdsInstreamCompletedEvent: {
        event: 'ADS_INSTREAM_COMPLETED',
        type: 'EVENT_TYPE_TRACK',
    },
};
